<template>
  <div class="sm-menu" v-if="menuWithRichData" :style="smHomeStyle">
    <div class="sm-date">
      {{ displayedTitle }}
    </div>
    <div class="sm-date sm-date2" v-if="displayedSubtitle" v-html="displayedSubtitle"></div>
    
    <div class="sm-menu-intro" v-html="menuWithRichData.intro1Html">
    </div>
    
    <div class="sm-miam">Faim de saison</div>
    <div class="sm-sep">        
      <svg class="vL6BBg" viewBox="0 0 500 34.7" style="overflow: hidden;"><path class="SQ2ADw _682gpw" d="M499.7,6.7C500.4,5.8 499.8,4.1 498.4,4.5C495.2,5.6 492.3,8.3 489.6,10.4C486.9,12.4 484.2,14.4 481.6,16.4C481.4,16.3 481.2,16.3 481,16.3C475.1,16.4 469.1,16.4 463.2,16.5L469.2,11.7C472.2,9.3 475.7,7 478.3,4.1C479.3,2.9 478,1.2 476.6,1.9C473.4,3.5 470.6,6.3 468,8.7C465.4,11.1 462.9,13.7 460.7,16.4C454.1,16.5 447.4,16.6 440.8,16.6C442.3,14.3 443.9,12 445.6,9.7C447.6,7 450.4,4.4 451.6,1.3C452,0.3 450.6,-0.7 449.8,-0.1C447,1.6 445.2,5.1 443.4,7.7C441.5,10.6 439.7,13.5 438.2,16.6C400.1,17 362,17.5 323.9,18.1C298.9,18.7 274.4,19.2 250.1,19.8L250,19.8C225.5,19.2 201.2,18.7 176.2,18.7C138.2,17.7 100.1,17.3 62,16.9C60.4,13.8 58.7,10.8 56.8,8C55,5.4 53.1,1.9 50.4,0.2C49.5,-0.3 48.2,0.6 48.6,1.6C49.8,4.8 52.6,7.3 54.6,10C56.3,12.2 57.8,14.5 59.4,16.9C52.8,16.8 46.1,16.7 39.5,16.7C37.3,13.9 34.8,11.4 32.2,9C29.6,6.6 26.8,3.8 23.6,2.2C22.2,1.5 20.9,3.2 21.9,4.4C24.4,7.3 28,9.5 31,12L37,16.8C30.9,16.5 25,16.5 19,16.4C18.8,16.4 18.6,16.4 18.4,16.5C15.8,14.4 13.1,12.4 10.4,10.5C7.7,8.5 4.8,5.7 1.6,4.6C0.2,4.1 -0.4,5.9 0.3,6.8C2.3,9.3 5.6,11 8.3,12.9C11,14.8 13.7,16.6 16.4,18.4C11.2,21.5 5.6,24.6 1.3,28.6C0,29.8 1.7,31.5 3,30.9C8.7,28.2 14.1,23.7 19.1,19.9C24.9,20 30.7,20.1 36.6,20.2C34.3,21.8 32,23.5 29.7,25.2C27,27.2 23.7,29.1 21.6,31.7C20.7,32.9 21.8,34.3 23.2,33.7C26.2,32.3 28.9,29.6 31.5,27.6C34.4,25.2 37.4,22.9 40.2,20.4C40.2,20.4 40.2,20.3 40.3,20.3L58.7,20.6C56.9,22.3 55.2,24 53.4,25.7C51.1,27.9 47.7,30.3 46.4,33.2C45.9,34.4 46.9,35.4 48.1,34.9C51,33.6 53.4,30.2 55.7,28C58.1,25.6 60.4,23.2 62.7,20.8C100.4,21.4 138.1,22.1 175.8,22.6L176.2,22.6C199.8,22.5 222.7,22.8 245.7,23C245.8,23 246,23.1 246.2,23.1L254,23.1C254.2,23.1 254.3,23.1 254.5,23C277.6,22.8 300.7,22.5 324.4,22C362,21.5 399.8,20.8 437.4,20.2C439.7,22.7 442.1,25 444.4,27.4C446.7,29.7 449,33 452,34.3C453.1,34.8 454.2,33.8 453.7,32.6C452.3,29.7 449,27.3 446.7,25.1C445,23.4 443.2,21.7 441.4,20L459.8,19.7C459.8,19.7 459.8,19.8 459.9,19.8C462.7,22.3 465.6,24.6 468.6,27C471.2,29.1 473.9,31.8 476.9,33.1C478.3,33.7 479.4,32.2 478.5,31.1C476.4,28.5 473.1,26.6 470.4,24.6C468.1,22.9 465.8,21.3 463.5,19.6C469.3,19.5 475.1,19.4 481,19.3C486.1,23.1 491.5,27.6 497.1,30.3C498.5,31 500.1,29.2 498.8,28C494.5,24 488.9,20.9 483.7,17.8C486.4,16 489.1,14.2 491.8,12.3C494.4,11 497.7,9.3 499.7,6.7" fill="#000000" style="touch-action: pan-x pan-y pinch-zoom;"></path></svg>
    </div>

    <div class="sm-menu-intro" v-html="menuWithRichData.intro2Html">
    </div>
    
    <template 
      v-for="(item, itemIndex) in menuWithRichData.foodMenuItems" 
      :key="itemIndex"
      >
    <div class="sm-menu-item">
      <div class="sm-menu-item-title" v-html="item.labelHtml"></div>
      <div class="sm-menu-item-title-mobile" v-html="item.labelHtmlNoLineReturn"></div>
      <div class="sm-menu-item-description" v-html="item.descriptionHtml"></div>
      <div class="sm-menu-item-description-mobile" v-html="item.descriptionHtmlNoLineReturn"></div>
      <div class="sm-menu-item-price" v-html="item.priceHtml"></div>
      

      <div class="allergenes" v-show="displayAllergenes">
        <h4>Allergènes</h4>
        
        <div v-if="!item.allGluten && !item.allCrustrace && !item.allOeuf && !item.allPoisson && !item.allArachide && !item.allSoja && !item.allLait && !item.allFruitCoques && !item.allCeleri && !item.allMoutarde && !item.allSesame && !item.allSulfite && !item.allLupin && !item.allMollusque">
          Aucun allergène renseigné. En cas de doute, contactez-moi.
        </div>
        <ul v-else>
          <li v-if="item.allGluten">
            Céréales contenant du gluten (blé, seigle, orge, avoine, épeautre, kamut ou leurs souches hybridées) et produits à base de ces céréales.
          </li>
          <li v-if="item.allCrustrace">
            Crustacés et produits à base de crustacés	
          </li>
          <li v-if="item.allOeuf">
            Oeufs et produits à base d'oeufs	
          </li>
          <li v-if="item.allPoisson">
            Poissons et produits à base de poissons	
          </li>
          <li v-if="item.allArachide">
            Arachides et produits à base d’arachide	
          </li>
          <li v-if="item.allSoja">
            Soja et produits à base de soja	
          </li>
          <li v-if="item.allLait">
            Lait et produits à base de lait (y compris de lactose)	
          </li>
          <li v-if="item.allFruitCoques">
            Fruits à coques (amandes, noisettes, noix, noix de : cajou, pécan, macadamia, du Brésil, du Queensland, pistaches) et produits à base de ces fruits.
          </li>
          <li v-if="item.allCeleri">
            Céleri et produits à base de céleri	
          </li>
          <li v-if="item.allMoutarde">
            Moutarde et produits à base de moutarde	
          </li>
          <li v-if="item.allSesame">
            Graines de sésame et  produits à base de graines de sésame	
          </li>
          <li v-if="item.allSulfite">
            Anhydride sulfureux et sulfites en concentration de plus de 10mg/kg ou 10 mg/l (exprimés en SO2).	
          </li>
          <li v-if="item.allLupin">
            Lupin et produits à base de lupin	
          </li>
          <li v-if="item.allMollusque">
            Mollusques et produits à base de mollusques	
          </li>
        </ul>
      </div>
      
      <div class="sm-menu-item-icons" v-if="item.vegan || item.vege || item.lactoseFree || item.glutenFree || item.lowGluten || item.lowSugar">
        <IconVegan v-if="item.vegan"/>
        <IconVegetarien v-if="!item.vegan && (item.vegetarien || item.vege)"/>
        <IconSansGluten v-if="item.glutenFree"/>
        <IconSansLactose v-if="item.lactoseFree"/>
        <IconFaibleGluten v-if="!item.lactoseFree && item.lowGluten"/>
        <IconFaibleSucre v-if="item.lowSugar"/>     
      </div>
      
      <div 
        class="item-order" 
        :class="{
          'mode-single': item.foodMenuItemOptions.length == 1,
          'mode-multiple': item.foodMenuItemOptions.length >= 2
        }"
        v-if="orderMode && item.id"
        >
        <div class="item-order-sub">
          <div class="order-your-order-intro">
            <span>
              Votre commande : 
            </span>
          </div>
          <div class="options-single-mode" v-if="item.foodMenuItemOptions.length == 1">
            
            <InputNumber 
              v-if="isAdmin || getFoodMenuItemRemainingWithoutOrder(item, item.foodMenuItemOptions[0]) >= 1" 
              v-model="order.foodMenuOrderItems[item.foodMenuItemOptions[0].id]" 
              showButtons 
              buttonLayout="horizontal" 
              :step="1"
              :min="0" 
              :max="isAdmin ? 9999 : getFoodMenuItemRemainingWithoutOrder(item, item.foodMenuItemOptions[0])" 
              :allowEmpty="false"
              :class="{'p-invalid':submitted && totalQuantity == 0}"
              />
            <span 
              v-else
              class="sold-out"
              >
              <!--
              Désolé, il n'en reste plus ! 
              -->
              Toutes les portions réservables ont trouvé preneur, mais pas d'inquiétude : des quantités supplémentaires seront disponibles directement sur place !
            </span>
          </div>
          <div class="options-multiple-mode" v-if="item.foodMenuItemOptions.length >= 2">
            <template
              v-for="(itemOption) in item.foodMenuItemOptions"
              :key="`itemOptions-${itemOption}`"
              >
              <div              
                class="options-multiple-mode-item"
              >
                <label>
                  <span>
                    {{itemOption.label}}
                  </span>
                </label>

                <InputNumber 
                  v-if="isAdmin || getFoodMenuItemRemainingWithoutOrder(item, itemOption) >= 1" 
                  v-model="order.foodMenuOrderItems[itemOption.id]" 
                  showButtons 
                  :min="0" 
                  :max="isAdmin ? 9999 : getFoodMenuItemRemainingWithoutOrderButRelatedToOthers(item, itemOption)" 
                  buttonLayout="horizontal" 
                  :allowEmpty="false"
                  :class="{'p-invalid':submitted && totalQuantity == 0}"
                  />
                  <span 
                    v-else
                    class="sold-out"
                    >
                    <!--
                    Désolé, il n'en reste plus !
                    -->
                    Toutes les portions réservables ont trouvé preneur, mais pas d'inquiétude : des quantités supplémentaires seront disponibles directement sur place !
                  </span>
              </div>      
               
              <div class="warning-low-quantity"
                v-if="getFoodMenuItemRemaining(item, itemOption) == 0 && getFoodMenuItemRemainingWithoutOrder(item, itemOption) >= 1"
                >
                <!--
                Après vous, il n'en restera plus !
                -->
                Après vous, toutes les portions réservables auront trouvé preneur, mais pas d'inquiétude : des quantités supplémentaires seront disponibles directement sur place !
              </div>
              <div class="warning-low-quantity"
                v-if="getFoodMenuItemRemaining(item, itemOption) == 1"
                >
                {{getFoodMenuItemRemaining(item, itemOption)}} restant
              </div>
              <div class="warning-low-quantity"
                v-if="getFoodMenuItemRemaining(item, itemOption) <= remainingLimitDisplay  && getFoodMenuItemRemaining(item, itemOption) > 1"
                >
                {{getFoodMenuItemRemaining(item, itemOption)}} restants
              </div>
            </template>
          </div>
        </div>

        <div class="warning-low-quantity"
          v-if="item.foodMenuItemOptions.length == 1 && getFoodMenuItemRemaining(item, item.foodMenuItemOptions[0]) == 0 && getFoodMenuItemRemainingWithoutOrder(item, item.foodMenuItemOptions[0]) >= 1"
          >
          <!--
          Après vous, il n'en restera plus !
          -->
          Après vous, toutes les portions réservables auront trouvé preneur, mais pas d'inquiétude : des quantités supplémentaires seront disponibles directement sur place !
        </div>
        <div class="warning-low-quantity"
          v-if="item.foodMenuItemOptions.length == 1 && getFoodMenuItemRemaining(item, item.foodMenuItemOptions[0]) == 1"
          >
          {{getFoodMenuItemRemaining(item, item.foodMenuItemOptions[0])}} restant
        </div>
        <div class="warning-low-quantity"
          v-if="item.foodMenuItemOptions.length == 1 && getFoodMenuItemRemaining(item, item.foodMenuItemOptions[0]) <= remainingLimitDisplay  && getFoodMenuItemRemaining(item, item.foodMenuItemOptions[0]) > 1"
          >
          {{getFoodMenuItemRemaining(item, item.foodMenuItemOptions[0])}} restants
        </div>
        <div class="sub-total" v-if="showSubTotalFor(item)">
          Sous-total : {{formatCurrency(subTotalFor(item))}}
        </div>
      </div>

    </div>
    <img v-if="printMode && itemIndex < menuWithRichData.foodMenuItems.length - 1" class="menu-item-print-separator" src="~@/assets/bol.svg" />
    </template>

    <div class="total-price" v-if="orderMode && totalPrice > 0">
      Total : {{formatCurrency(totalPrice)}}
    </div>
    
    <div class="sm-menu-outtro" v-if="menuWithRichData.outtro1Html" v-html="menuWithRichData.outtro1Html">
    </div>
    
    <div class="sm-menu-outtro" v-if="menuWithRichData.outtro2Html" v-html="menuWithRichData.outtro2Html">
    </div>
    <div class="sm-menu-corner" v-if="menuWithRichData.corner && menuWithRichData.corner != 'A MODIFIER'">
      <div class="sm-menu-corner-img">
        <img src="~@/assets/corner.svg" />
      </div>
      <div class="sm-menu-corner-content">
        <div class="sm-menu-corner-content-content" v-html="menuWithRichData.cornerHtml"></div>
      </div>        
    </div>
  </div>
  <div class="sm-after-menu">&nbsp;</div>
</template>

<script>
import { computed, watch, ref } from 'vue';
import replaceHtml from '../misc/replaceHtml'
import normalizeMenu from '../misc/normalizeMenu';

import IconVegan from "./icons/IconVegan.vue";
import IconVegetarien from "./icons/IconVegetarien.vue";
import IconSansLactose from "./icons/IconSansLactose.vue";
import IconSansGluten from "./icons/IconSansGluten.vue";
import IconFaibleGluten from "./icons/IconFaibleGluten.vue";
import IconFaibleSucre from "./icons/IconFaibleSucre.vue";

import { storeToRefs } from 'pinia';
import { useAdminDataStore } from '../stores/admin';

export default {
  name: "Menu",
  props: {
    menu: {
      type: Object,
    },
    orderMode: {
      type: Boolean,
    },
    inputOrder: {
      type: Object,
    },
    submitted: {
      type: Boolean,
    },    
    displayAllergenes: {
      type: Boolean,
    },
    isPreview: {
      type: Boolean,
    },
    zoom: {
      type: Number,
      default: 100,
    },
    printMode: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const orderMode = computed(() => props.orderMode);

    const adminDataStore = useAdminDataStore();

    const { isAuthenticated: isAdmin } = storeToRefs(adminDataStore);

    const menuWithRichData = computed(() => {
      const menu = normalizeMenu(props.menu, true, adminDataStore.foodRecipes);
      
      if(!menu) {
        return null;
      }
      return {
        ...menu,
        foodMenuItems: (menu.foodMenuItems || [])
        .filter(item => !item.deleted)
        .map(item => ({
          ...item,
          labelHtml: replaceHtml(item.label, '', false),
          labelHtmlNoLineReturn: replaceHtml(item.label, '', true),
          descriptionHtml: replaceHtml(item.description, '', false),
          descriptionHtmlNoLineReturn: replaceHtml(item.description, '', true),
          priceHtml: replaceHtml(item.price, ''),
        })).filter(item => item && item.label),
        dateHtml: replaceHtml(menu.date, ''),
        menuDate2Html: replaceHtml(menu.menuDate2, ''),
        intro1Html: replaceHtml(menu.intro1, ''),
        intro2Html: replaceHtml(menu.intro2, ''),
        outtro1Html: replaceHtml(menu.outtro1, ''),
        outtro2Html: replaceHtml(menu.outtro2, ''),
        cornerHtml: replaceHtml(menu.corner, ''),
      };
    });

    const displayedTitle = computed(() => {
      if(props.printMode) {
        return 'Au menu';
      }
      return props.menu?.menuDate || '';
    });

    const displayedSubtitle = computed(() => {
      if(props.printMode) {
        return replaceHtml(props.menu?.name || props.menu?.menuDate || '', '');
      }
      return menuWithRichData.value?.menuDate2Html || '';
    });

    const order = ref({...(props.inputOrder || {foodMenuOrderItems: []})});
    if(!props.isPreview) {
      watch(menuWithRichData, () => {
        order.value.foodMenuId = menuWithRichData.value.id;
        context.emit('orderUpdated', order.value);
      }, {deep: true, immediate: true});
    }
    

    const inputOrder = computed(() => props.inputOrder);
    watch(inputOrder, () => {
      const newOrderValue = {...(inputOrder.value || {})};
      newOrderValue.foodMenuId = menuWithRichData.value.id;
      if(!newOrderValue.foodMenuOrderItems) {
        newOrderValue.foodMenuOrderItems = {};
      }
      menuWithRichData.value.foodMenuItems.forEach((foodMenuItem) => {
        foodMenuItem.foodMenuItemOptions.forEach((foodMenuItemOption) => {
          newOrderValue.foodMenuOrderItems[foodMenuItemOption.id] = order.value.foodMenuOrderItems ? (order.value.foodMenuOrderItems[foodMenuItemOption.id] || newOrderValue.foodMenuOrderItems[foodMenuItemOption.id] || 0) : 0;
        })
      });
      order.value = newOrderValue;
    },  {immediate: true, deep: true});

    const showSubTotalFor = (foodMenuItem) => {
      let itemCount = 0;
      foodMenuItem.foodMenuItemOptions.forEach((foodMenuItemOption)=> {
        if(order.value.foodMenuOrderItems[foodMenuItemOption.id] > 0) {
          itemCount+=order.value.foodMenuOrderItems[foodMenuItemOption.id];
        }
      });
      return itemCount >= 1;
    };
    const subTotalFor = (foodMenuItem) => {
      var subTotal = 0;
      foodMenuItem.foodMenuItemOptions.forEach((foodMenuItemOption)=> {
        if(order.value.foodMenuOrderItems[foodMenuItemOption.id] > 0) {
          let remainingsCount = order.value.foodMenuOrderItems[foodMenuItemOption.id];
          const discounts = foodMenuItemOption.foodMenuItemOptionDiscounts.filter(d => !d.deleted);
          discounts.forEach((discount) => {
            const nbLot = Math.floor(remainingsCount / discount.quantity);
            if(nbLot >= 1) {
              subTotal += discount.price * nbLot;  
              remainingsCount -= (nbLot * discount.quantity);
            }
          });

          if(remainingsCount > 0) {
            subTotal += foodMenuItemOption.price * remainingsCount;
          }
        }
      });
      return subTotal;
    };
    const totalPrice = computed(() => {
      var total = 0;
      menuWithRichData.value.foodMenuItems.forEach((foodMenuItem) => {
        foodMenuItem.foodMenuItemOptions.forEach((foodMenuItemOption) => {
          if(order.value.foodMenuOrderItems[foodMenuItemOption.id] > 0) {


            let remainingsCount = order.value.foodMenuOrderItems[foodMenuItemOption.id];
            const discounts = foodMenuItemOption.foodMenuItemOptionDiscounts.filter(d => !d.deleted);
            discounts.forEach((discount) => {
              const nbLot = Math.floor(remainingsCount / discount.quantity);
              if(nbLot >= 1) {
                total += discount.price * nbLot;  
                remainingsCount -= (nbLot * discount.quantity);
              }
            });

            if(remainingsCount > 0) {
              total += foodMenuItemOption.price * remainingsCount;
            }


            //total += foodMenuItemOption.price * order.value.foodMenuOrderItems[foodMenuItemOption.id];
          }
        });
      });
      return total;
    });

    
    const totalQuantity = computed(() => {
      var total = 0;
      menuWithRichData.value.foodMenuItems.forEach((foodMenuItem) => {
        foodMenuItem.foodMenuItemOptions.forEach((foodMenuItemOption) => {
          if(order.value.foodMenuOrderItems[foodMenuItemOption.id] > 0) {
            total += order.value.foodMenuOrderItems[foodMenuItemOption.id];
          }
        });
      });
      return total;
    });

    watch(order, () => {
      context.emit('orderUpdated', order.value);
    }, {deep: true});

    
    const currencyFormatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    });

    const formatCurrency = (value) => {
      return currencyFormatter.format(value);
    };

    const itemOptionsMaximumQuantities = computed(() => {
      const calc = {};

      menuWithRichData.value.foodMenuItems.forEach((fmi) => {
        let initialOrderFmiQuantity = 0;
        let actualOrderFmiQuantity = 0;
        fmi.foodMenuItemOptions.forEach((fmio) => {
          const fmioInitialOrderedQuantity = order.value.initialFoodMenuOrderItems ? (order.value.initialFoodMenuOrderItems[fmio.id] || 0) : 0;
          initialOrderFmiQuantity += fmioInitialOrderedQuantity;

          const orderedQuantity = order.value.foodMenuOrderItems[fmio.id];
          actualOrderFmiQuantity += orderedQuantity;
        });

        calc[`fmi-${fmi.id}-${fmi.label}`] = {
          fmi,
          maximumQuantity: fmi.maximumQuantity,
          remainingQuantity: fmi.remainingQuantity,
          initialOrderFmiQuantity: initialOrderFmiQuantity,
          actualOrderFmiQuantity: actualOrderFmiQuantity,
        };

        const fmiRemainingQuantity = fmi.remainingQuantity + initialOrderFmiQuantity;

        fmi.foodMenuItemOptions.forEach((fmio) => {
          // order.value.foodMenuOrderItems[itemOption.id]

          let fmioRemainingQuantity = fmio.remainingQuantity;
          const fmioInitialOrderedQuantity = order.value.initialFoodMenuOrderItems ? (order.value.initialFoodMenuOrderItems[fmio.id] || 0) : 0;
          
          let fmioRemainingQuantityWithoutThisOrder = fmioRemainingQuantity + fmioInitialOrderedQuantity;

          const orderedQuantity = order.value.foodMenuOrderItems[fmio.id];

          let theFmioRemainingQuantityMinus = Math.min(
            fmiRemainingQuantity - actualOrderFmiQuantity, 
            fmioRemainingQuantityWithoutThisOrder - orderedQuantity
          );

          let theFmioRemainingQuantityMinusWithoutOrder = Math.min(
            fmiRemainingQuantity, 
            fmioRemainingQuantityWithoutThisOrder
          );
          
          calc[fmio.id] = {
            theFmioRemainingQuantityMinus,
            theFmioRemainingQuantityMinusWithoutOrder,
            fmiRemainingQuantity,
            fmiRemainingQuantityMinusOrderedQuantity: fmiRemainingQuantity - orderedQuantity,
            fmioRemainingQuantityWithoutThisOrder,
            fmioRemainingQuantityWithoutThisOrderMinusOrderedQuantity: fmioRemainingQuantityWithoutThisOrder - orderedQuantity,
            orderedQuantity,
          };
        });
      });

      return calc;
    });



    const getFoodMenuItemRemainingWithoutOrder = (item, itemOption) => {
      return itemOptionsMaximumQuantities.value[itemOption.id].theFmioRemainingQuantityMinusWithoutOrder;
    };
    
    
    const getFoodMenuItemRemainingWithoutOrderButRelatedToOthers = (item, itemOption) => {
      return itemOptionsMaximumQuantities.value[itemOption.id].theFmioRemainingQuantityMinusWithoutOrder;
    };

    const getFoodMenuItemRemaining = (item, itemOption) => {
      return itemOptionsMaximumQuantities.value[itemOption.id].theFmioRemainingQuantityMinus;
    };


    const smHomeStyle = computed(() => {
      if(props.zoom != 100) {
        //return `transform: scale(${props.zoom}); transform-origin: top left;`;
        return 'zoom: '+ props.zoom + '%; width: '+(710.0 / (props.zoom / 100.0)) + 'px;';
      }
      if(orderMode.value) {
        return '';
      }
      if(menuWithRichData.value.cssMaxWidth) {
        return `max-width: min(${menuWithRichData.value.cssMaxWidth}px,100vw - 260px)`;
      }
      return '';
    });

    return {
      itemOptionsMaximumQuantities,
      isAdmin,
      formatCurrency,
      getFoodMenuItemRemaining,
      getFoodMenuItemRemainingWithoutOrder,
      getFoodMenuItemRemainingWithoutOrderButRelatedToOthers,
      displayedSubtitle,
      displayedTitle,
      menuWithRichData,
      order,
      publicPath: '/',
      remainingLimitDisplay: 5,
      showSubTotalFor,
      smHomeStyle,
      subTotalFor,
      totalPrice,
      totalQuantity,
    };
  },
  components: {    
    IconSansLactose,
    IconVegan,
    IconVegetarien,
    IconSansGluten,
    IconFaibleGluten,
    IconFaibleSucre,
  },
  emits: ['orderUpdated'],
};
</script>